import { ComboField } from '@components/Fields/ComboField';
import { FilterBar } from '@components/FilterBar';
import { GridItem } from '@components/GridItem';
import { PrimaryButton } from '@components/Buttons/PrimaryButton';
import { IFilter } from '@hooks/useFilter';
import { IModalWindow } from '@hooks/useModalWindow';
import { MenuItem } from '@material-ui/core';
import { EnumFaturaStatus, IComboFaturaStatus } from '@model/FaturaStatus';
import { IFaturaFilter } from '@services/ClienteService';
import React from 'react';

export type FaturaFilterProps = {
    filter: IFilter<IFaturaFilter>
    faturaStatusCombo: IComboFaturaStatus
    isLoading: boolean
    registrarFaturaModal: IModalWindow
    gerarFaturasAntecipadas: IModalWindow
}

export function FaturaFilter ({ registrarFaturaModal, gerarFaturasAntecipadas, filter, faturaStatusCombo, isLoading }: FaturaFilterProps) {
    const { fields } = filter;

    return (
        <FilterBar>
            <GridItem>
                <PrimaryButton onClick={registrarFaturaModal.open}>Nova Fatura Manual</PrimaryButton>
            </GridItem>

            <GridItem floatRight>
                {
                    faturaStatusCombo.set.length > 0 && (
                        <ComboField
                            field={fields.faturaStatus}
                            disabled={isLoading}
                            updateFieldStateOnChange
                            onValueChanged={(value: EnumFaturaStatus) => {
                                if (value !== fields.faturaStatus.value) {
                                    filter.handleFilterRequest();
                                }
                            }}
                        >
                            <MenuItem key={0} value={EnumFaturaStatus.None}>Status: Todos</MenuItem>
                            {
                                faturaStatusCombo.createOptions({
                                    prefix: "Status: "
                                })
                            }
                        </ComboField>
                    )
                }
            </GridItem>
        </FilterBar>
    )
}